import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SuperAdminPageLayout from '../../../layout/SuperAdminPageLayout';
const EditInstitutionPage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    return (_jsx(SuperAdminPageLayout, { title: t('admin.edit_institution'), unitIid: id, formType: 'edit', unit: 'institution' }));
};
export default EditInstitutionPage;
